import { render, staticRenderFns } from "./DashboardFooter.vue?vue&type=template&id=706360da&scoped=true&"
import script from "./DashboardFooter.vue?vue&type=script&lang=js&"
export * from "./DashboardFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706360da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('706360da')) {
      api.createRecord('706360da', component.options)
    } else {
      api.reload('706360da', component.options)
    }
    module.hot.accept("./DashboardFooter.vue?vue&type=template&id=706360da&scoped=true&", function () {
      api.rerender('706360da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/layouts/Dashboard/partials/DashboardFooter.vue"
export default component.exports